import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EduContentSearchResultInterface } from '@campus/shared';
import { Category } from './../../interfaces';

@Component({
  selector: 'campus-toc-result-grid-item-groups',
  templateUrl: './toc-result-grid-item-groups.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TocResultGridItemGroupsComponent {
  @Input() category: Category;

  @Output() selectionChange = new EventEmitter<{ value: EduContentSearchResultInterface; checked: boolean }>();

  onEduContentSelectionChange(event: { value: EduContentSearchResultInterface; checked: boolean }) {
    this.selectionChange.emit(event);
  }
}
